<template>
  <div class="formula-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>公式名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入公式名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>收费类型</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.type" class="app-block" placeholder="请选择收费类型">
              <a-select-option :value="value.id" v-for="value in typeOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newFormula()">新增公式</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :disabled="!!data.is_default" :checked="data.is_show === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editFormula(data)">编辑</a-button>
          <a-button type="link" @click="deleteFormula(data)" v-if="!data.is_default">删除</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
  import ChargeTypeService from '@/io/charge_type.js';
  import FormulaService from '@/io/formula.js';

  export default {
    name: 'FormulaManage',
    data() {
      let self = this;
      return {
        typeOptions: [],
        table: {
          loading: false,
          search: {
            name: null,
            type: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '公式名称',
              dataIndex: 'name'
            },
            {
              title: '收费类型',
              dataIndex: 'expenses_type_name'
            },
            {
              title: '状态',
              scopedSlots: { customRender: 'state' }
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    activated () {
      this.initType().then(() => {
        this.initData();
      });
    },
    methods: {
      initType() {
        return ChargeTypeService.list().then(res => {
          this.typeOptions = res;
        }).catch(err => {});
      },
      stateChange(data) {
        let checked = data.is_show === 1;
        data.stateLoading = true;
        FormulaService.switchStatus(data.id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.is_show = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      editFormula(data) {
        this.$router.push({
          name: 'EditFormula',
          params: {
            id: data.id
          }
        });
      },
      deleteFormula(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此公式？',
          onOk() {
            FormulaService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      newFormula() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewFormula'
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          type: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return FormulaService.listPage(
          this.table.search.name,
          this.table.search.type,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>